import { Reveal, SectionTag, SectionHeading } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Zero backlog, zero black holes",
    body: "Every order is processed live and tracked in real time — no more chasing status emails or discovering a stalled order a week later. Your order desk moves while you sell.",
    testId: "manifesto-chapter-01",
  },
  {
    num: "02",
    title: "Precision artistry, on demand",
    body: "Print-ready vector art and virtual proofs delivered by a dedicated design team that knows promotional decoration inside out.",
    testId: "manifesto-chapter-02",
  },
  {
    num: "03",
    title: "Your hours are our hours",
    body: "Our team's availability aligns with your business hours. Whether you close at 5pm in New York, Toronto, London, or Sydney — your dedicated team is live when you are.",
    testId: "manifesto-chapter-03",
  },
];

const Manifesto = () => (
  <section id="manifesto" className="relative bg-[#F8FAFC] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionTag index="01" label="The Manifesto" testId="manifesto-section-tag" />
      <div className="mt-6 max-w-2xl">
        <SectionHeading>Why distributors run on Artwork360</SectionHeading>
      </div>

      <div className="mt-16">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.1}>
            <div
              data-testid={c.testId}
              className="group grid grid-cols-1 gap-4 border-t border-slate-200 py-10 transition-colors duration-500 last:border-b hover:bg-slate-50 sm:grid-cols-12 sm:gap-8 sm:py-12"
            >
              <div className="sm:col-span-3">
                <span className="font-display text-5xl font-extrabold text-outline transition-colors duration-500 group-hover:text-[#2E3192] group-hover:[-webkit-text-stroke:0px] sm:text-6xl">
                  {c.num}
                </span>
              </div>
              <div className="sm:col-span-4">
                <h3 className="font-display text-xl font-bold text-slate-900 sm:text-2xl">{c.title}</h3>
              </div>
              <div className="sm:col-span-5">
                <p className="text-sm leading-relaxed text-slate-500 sm:text-base">{c.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
